import naja from 'naja';
import Modal from '../classes/modal';
import Ajax from '../utils/ajax';
import Helpers from '../helpers';

export function initModal() {
  window.aui = {
    ...window.aui,
    modal: Modal,
    activeModal: null
  }
}

export function initModalPrompt() {
  const el = document.querySelector('[data-aui-modal-prompt]');
  if (!el) return;

  const modalData = JSON.parse(el.textContent);
  const { id, once: showOnce = true, ...options } = modalData;

  const once = showOnce ? Helpers.once(`modal:${id}`) : null;

  if (showOnce && !once) return;

  new window.aui.modal({
    ...options,
    onClose: () => once?.commit()
  });
}

export function initModalGet(paramContainer) {
  const container = paramContainer || document.body;

  container.querySelectorAll('[data-aui-modal-get]')?.forEach((element) => {
    if (element.tagName?.toUpperCase() === 'A' && element.hasAttribute('href')) {
      element.addEventListener('click', async (event) => {
        event.preventDefault();

        let response;
        try {
          response = await Ajax.get(
              element.getAttribute('href'),
              {},
              {
                history: false,
                loaderElement: window?.aui?.activeModal?.options?.el?.querySelector('[data-aui-modal-container]')
              }
          );
        } catch {
          return;
        }

        if (response) {
          const modal = window?.aui?.activeModal ?? new window.aui.modal();

          naja.snippetHandler.updateSnippet(modal.options.el.querySelector('[data-aui-modal-title]'), response.title);
          naja.snippetHandler.updateSnippet(modal.options.el.querySelector('[data-aui-modal-body]'), response.body);
        }
      });
    }
  });
}

naja.addEventListener('init', () => {
  initModal();
  initModalPrompt();
  initModalGet(document.body);
});

naja.snippetHandler.addEventListener('afterUpdate', (event) => {
  initModalGet(event.detail.snippet);
});